/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ComponentClassNames, mergeStyleSets } from "@microsoft/shifts-ui-core";

export interface BaseShiftClassOptions {
    addMarginBottom?: boolean;
    addMarginTop?: boolean;
}

export type BaseShiftStyles = "themeContainer" | "root" | "title" | "icon" | "teamsLocationAddIcon" | "titleLayout" | "notes";

/**
 * Gets the 'BaseShift' component CSS class names.
 * @returns The 'BaseShift' component CSS class names.
 */
export const getClassNames = (options: BaseShiftClassOptions = {}): ComponentClassNames<BaseShiftStyles> => {
    const { addMarginBottom, addMarginTop } = options;

    return mergeStyleSets({
        themeContainer: {
            ...(addMarginTop ? { marginTop: "0.5rem" } : {})
        },
        root: {
            padding: "0.25rem 0.5rem",
            fontSize: "0.75rem",
            textOverflow: "ellipsis"
        },
        title: {
            fontWeight: "600"
        },
        icon: {
            height: "1rem",
            width: "1rem"
        },
        teamsLocationAddIcon: {
            // styles were removed, class declaration left for future references
        },
        titleLayout: {
            "align-items": "center",
            ...(addMarginBottom ? { marginBottom: "0.625rem" } : {})
        },
        notes: {
            "overflow-wrap": "break-word"
        }
    });
};